module.exports = "https://r.zoocdn.com/_next/static/images/hero-800-ea421f674f8652208801291375fc2a7d.jpg";